// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import { SxProps, Theme } from '@mui/material/styles';
import { awMutedGrey, awSwitchLiftShadow, awSwitchTrackGrey } from 'Utils/themes';

// Below this width of the containing rail the segments show their icons alone, leaving the
// search pill beside the switch room to type in.
const LABELLED_MIN_CONTAINER_WIDTH_PX = 400;

// Figma "Proposed — Projects list": a grey track holding two segments; the active one is a white
// pill lifted by a soft shadow. Sized to the 38px search pill and list/cards switch it shares a
// row with: a 3px track around 32px segments.
const styles = (theme: Theme): Record<string, SxProps<Theme>> => ({
  track: {
    flexShrink: 0,
    padding: '3px',
    gap: '3px',
    borderRadius: '8px',
    backgroundColor: awSwitchTrackGrey,
    // MUI joins grouped buttons with shared borders and squared inner corners; the design draws
    // each segment as its own rounded pill with no border at all.
    '& .MuiToggleButtonGroup-grouped': {
      border: 0,
      borderRadius: '6px',
      marginLeft: 0,
    },
    '& .MuiToggleButtonGroup-grouped:not(:first-of-type), & .MuiToggleButtonGroup-grouped:not(:last-of-type)': {
      borderRadius: '6px',
      marginLeft: 0,
      borderLeft: 0,
    },
  },
  segment: {
    height: '32px',
    padding: '0 12px',
    gap: '6px',
    fontSize: '13px',
    fontWeight: 500,
    letterSpacing: '0.5px',
    textTransform: 'none',
    whiteSpace: 'nowrap',
    color: awMutedGrey,
    '&:hover': {
      backgroundColor: 'transparent',
      color: theme.palette.text.primary,
    },
    '&.Mui-selected, &.Mui-selected:hover': {
      backgroundColor: theme.palette.common.white,
      color: theme.palette.text.primary,
      fontWeight: 600,
      boxShadow: awSwitchLiftShadow,
    },
  },
  segmentIcon: {
    fontSize: '16px',
  },
  // The label hides in a narrow container (the map rail at its floor); the segment keeps its
  // accessible name through aria-label.
  segmentLabel: {
    [`@container (max-width: ${LABELLED_MIN_CONTAINER_WIDTH_PX}px)`]: {
      display: 'none',
    },
  },
});

export default styles;
